import { Provider } from '@angular/core';
import { ApparelApiService, provideApparelApiOrigin } from '@isaia/apparel';
import { ApparelService } from './apparel.service';
import { ApparelRepository } from './apparel.repository';

export function provideApparel(options: { origin: string }): Provider {
  return [provideApparelApiOrigin(options.origin), ApparelApiService, ApparelService, ApparelRepository];
}
